export default "__VITE_ASSET__C8yqMwgo__"